import { Grid, Typography, Button } from "@mui/material";
import { PublicPortalRoutingService } from "@publicPortal/services/PublicPortalRoutingService";
import React from "react";
import { useNavigate } from "react-router-dom";

const publicPortalRouting = new PublicPortalRoutingService();

interface PublicLoginButtonProps {
    handleSignIn: () => Promise<void>;
}

const PublicLoginButtons: React.FC<PublicLoginButtonProps> = ({ handleSignIn }) => {
    const navigate = useNavigate();
    const createAccountOnClick = () => {
        navigate(publicPortalRouting.RegisterRoute());
    };
    const backToSearchOnClick = () => {
        navigate(publicPortalRouting.Root);
    };
    const forgotPasswordOnClick = () => {
        navigate(publicPortalRouting.ForgotPasswordRoute());
    };

    return (
        <>
            <Grid container justifyContent={"space-evenly"}>
                <Grid item>
                    <Typography variant="button" onClick={forgotPasswordOnClick}>
                        Forgot password?
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography variant="button" onClick={backToSearchOnClick}>
                        Back to search
                    </Typography>
                </Grid>
            </Grid>
            <Grid container justifyContent="center" alignItems="center" sx={{ marginTop: "2rem" }}>
                <Grid item xs={3} justifyContent="center">
                    <Button onClick={createAccountOnClick}>Create Account</Button>
                </Grid>
                <Grid item xs={3} textAlign="center">
                    <Button variant="contained" onClick={handleSignIn}>
                        Sign in
                    </Button>
                </Grid>
            </Grid>
        </>
    );
};

export default PublicLoginButtons;
